var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.55556 5.33335H12.4444V10.6667H3.55556V5.33335ZM14.6667 8.00002C14.6667 8.73641 15.2636 9.33335 16 9.33335V12C16 12.7364 15.4031 13.3334 14.6667 13.3334H1.33333C0.596944 13.3334 0 12.7364 0 12V9.33335C0.736389 9.33335 1.33333 8.73641 1.33333 8.00002C1.33333 7.26363 0.736389 6.66669 0 6.66669V4.00002C0 3.26363 0.596944 2.66669 1.33333 2.66669H14.6667C15.4031 2.66669 16 3.26363 16 4.00002V6.66669C15.2636 6.66669 14.6667 7.26363 14.6667 8.00002ZM13.3333 5.11113C13.3333 4.74294 13.0349 4.44446 12.6667 4.44446H3.33333C2.96514 4.44446 2.66667 4.74294 2.66667 5.11113V10.8889C2.66667 11.2571 2.96514 11.5556 3.33333 11.5556H12.6667C13.0349 11.5556 13.3333 11.2571 13.3333 10.8889V5.11113Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.9b22735abae3e6ec64bdb2a11766c8e5.svg";
export { ForwardRef as ReactComponent };